/*
 *   File : forgot-password.jsx
 *   Author : https://evoqins.com
 *   Description : forgot password page
 *   Integrations :
 *   Version : 1.0.0
 */

import React, { useRef, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

//Custom components
import { PrimaryButton } from "../../Components/Cta/index";
import Icon from "../../Components/icons";
import { Input, Password, OTPInput } from "../../Components/FormElements/index";
import { APIService } from "../../Service";

//custom style
import "../../Style/Pages/login.scss";

export default function ForgotPassword() {
  const otpInputRef = useRef(null);
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [loading, setLoading] = useState(false);

  const [otpModal, setOtpModal] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [focusedInput, setFocusedInput] = useState(2);
  const [confirmOTP, setConfirmOTP] = useState([]);
  const [otpError, setOtpError] = useState("");

  const [stage2, setStage2] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [tempToken, setTempToken] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", //scroll top
    });
  }, []);

  useEffect(() => {
    if (otpInputRef) return;
    otpInputRef.current[0]?.focus();
  }, []);

  useEffect(() => {
    setEmailError("");
  }, [email]);

  useEffect(() => {
    setPasswordError("");
  }, [password]);

  useEffect(() => {
    setConfirmPasswordError("");
  }, [confirmPassword]);

  useEffect(() => {
    setOtpError("");
  }, [otpValue]);

  // handle submit OTP
  const _handleSubmitOTP = () => {
    // if (otpValue.length < 4) {
    //   setOtpError("Enter received OTP");
    //   return;
    // }
    // setLoading(true);
    // setStage2(true);
    // setLoading(false);

    if (otpValue.length < 4) {
      setOtpError("Enter received OTP");
    }

    if (otpValue.length === 4) {
      _verifyOTP();
    }
  };

  // API - Verify OTP
  const _verifyOTP = () => {
    setLoading(true);
    let is_post = true;
    let url = "auth/verify-otp";
    let data = {
      email: email,
      otp: otpValue,
      type: "RESET_PASSWORD",
    };
    APIService(is_post, url, data).then((response) => {
      if (response.status_code === 200) {
        setStage2(true);
        setTempToken(response.temp_token);
      } else {
        otpInputRef.current[0]?.focus();
        toast.dismiss();
        toast.error(response.message, {
          type: "error",
          className: "e-toast",
        });
      }
      setOtpValue("");
      setConfirmOTP([]);
      setLoading(false);
    });
  };

  // handle OTP
  const _handleOTP = (e) => {
    // if (!loading) {
    //   const input_value = e.target.value.slice(0, 4); // keep only 4 chars

    //   // ✅ if wrong input (example: only allow digits or fixed OTP check)
    //   if (input_value && input_value !== "1234" && input_value.length === 4) {
    //     setOtpError("Invalid OTP");
    //     setOtpValue("");
    //     setConfirmOTP([]);
    //     setFocusedInput(2);

    //     if (otpInputRef.current) {
    //       otpInputRef.current.focus();
    //     }
    //     return; // stop here
    //   }

    //   // ✅ normal typing flow
    //   setOtpError("");
    //   setOtpValue(input_value);
    //   setConfirmOTP([...input_value]);
    // }
    if (loading !== true) {
      const input_value = e.target.value;
      if (input_value.length <= 4) {
        setOtpValue(input_value);
        const characters = [];

        for (let i = 0; i < input_value.length; i++) {
          const character = input_value.charAt(i);
          characters.push(character);
        }
        setConfirmOTP(characters);
      }
    }
  };

  // handle resend OTP
  const _handleResendOTP = () => {
    setOtpValue("");
    setConfirmOTP([]);
    _sentOTP();
  };

  // API - Send OTP
  const _sentOTP = () => {
    let is_post = true;
    let url = "auth/resend";
    let data = {
      email: email,
      type: "RESET_PASSWORD",
    };

    APIService(is_post, url, data).then((response) => {
      if (response.status_code === 200) {
        setOtpValue("");
        setConfirmOTP([]);
        // Cookies.set('access_token', response.access_token, { domain: process.env.REACT_APP_DOMAIN, path: '/' });
        toast.success(response.message, {
          type: "success",
          className: "e-toast",
        });
        // window.location.href = "/corridor-config";
      } else {
        toast.dismiss();
        toast.error(response.message, {
          type: "error",
          className: "e-toast",
        });
      }
    });
  };

  // Handles passwords
  const _handleConfirmPassword = (e) => {
    e.preventDefault();
    let isValid = true;
    if (password !== confirmPassword) {
      setPasswordError("Password does not match");
      isValid = false;
    } else if (password.length <= 0 && confirmPassword.length <= 0) {
      setPasswordError("Password does not match");
      isValid = false;
    }
    if (isValid === true) {
      _updatePassword();
    }
  };

  // API - change password
  const _updatePassword = () => {
    setLoading(true);
    let is_post = true;
    let url = "auth/reset-password";
    let data = {
      temp_token: tempToken,
      confirm_password: confirmPassword,
      password: password,
    };
    APIService(is_post, url, data).then((response) => {
      if (response.status_code === 200) {
        navigate("/");
        toast.dismiss();
        toast.success(response.message, {
          type: "success",
          className: "e-toast",
        });
      } else {
        toast.dismiss();
        toast.error(response.message, {
          type: "error",
          className: "e-toast",
        });
      }
      setLoading(false);
    });
  };

  // Handles email validation and shows OTP modal
  const _validateEmail = (e) => {
    // e.preventDefault();
    let isValid = true;
    let validate_email = /^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/;
    if (email.trim().length === 0) {
      setEmailError("Email is required");
      isValid = false;
    } else if (!validate_email.test(email)) {
      setEmailError("Please provide a valid email");
      isValid = false;
    }
    if (isValid === true) {
      _handleGetOTP();
    }
  };

  const _handleGetOTP = (e) => {
    _getOTP();
    // setOtpModal(true);
  };

  // API - get OTP
  const _getOTP = () => {
    setLoading(true);
    let is_post = true;
    let url = "auth/forgot-password";
    let data = {
      email: email,
    };

    APIService(is_post, url, data).then((response) => {
      if (response.status_code === 200) {
        toast.dismiss();
        toast.success(response.message, {
          type: "success",
          className: "e-toast",
        });
        setOtpModal(true);
      } else {
        toast.dismiss();
        toast.error(response.message, {
          type: "error",
          className: "e-toast",
        });
      }
      setLoading(false);
    });
  };

  return (
    <div className="col-12 e-pt-56px">
      <div className="row">
        <Link
          to=""
          className="text-decoration-none e-text-blue-violet d-flex align-items-center pb-3"
          onClick={(e) => {
            e.preventDefault();
            if (stage2) {
              setPassword("");
              setConfirmPassword("");
              setStage2(false);
              return;
            }
            if (otpModal) {
              setOtpModal(false);
              return;
            }
            navigate("/");
          }}
        >
          <Icon icon="arrow-left" size={15} color="e-text-blue-violet" />
          <span className="ps-2">Go back</span>
        </Link>

        <h3 className="e-text-black e-font-22 e-primary-font-poppins e-font-weight-600">
          {stage2
            ? "Set new password"
            : otpModal
            ? "OTP Verification"
            : "Reset Password"}
        </h3>
        <p className="e-text-black e-font-weight-400 e-font-14">
          {otpModal && !stage2 ? (
            <>
              Enter the 4-digit code sent to{" "}
              <span className="e-text-blue-violet">{email}</span>
            </>
          ) : (
            "Lorem ipsum dolor sit amet, consectetur."
          )}
        </p>
      </div>

      {stage2 ? (
        <>
          <div className="row pt-3">
            <Password
              id="2"
              label="Password"
              placeholder="Enter password"
              require={true}
              value={password}
              error={passwordError}
              autoFocus={true}
              className="e-primary-font-poppins w-100"
              onKeyPress={_handleConfirmPassword}
              handleChange={(e) => setPassword(e)}
            />
          </div>
          <div className="row pt-3">
            <Password
              id="3"
              label="Confirm Password"
              placeholder="Enter password"
              require={true}
              value={confirmPassword}
              error={confirmPasswordError}
              className="e-primary-font-poppins w-100"
              onKeyPress={_handleConfirmPassword}
              handleChange={(e) => setConfirmPassword(e)}
            />
          </div>

          <div className="row pt-4 px-2">
            {/* <PrimaryButton
              ClassName="e-border-radius-pill e-bg-blue-violet text-white e-primary-font-poppins fw-medium"
              name={loading ? "Please wait..." : "Confirm"}
              onPress={_handleConfirmPassword}
            /> */}
            {password.length > 0 && confirmPassword.length > 0 ? (
              <PrimaryButton
                name={"Confirm"}
                ClassName="e-border-radius-pill e-bg-blue-violet text-white e-primary-font-poppins fw-medium"
                loading={loading}
                onPress={_handleConfirmPassword}
              />
            ) : (
              <PrimaryButton
                name={"Confirm"}
                loading={loading}
                ClassName="e-border-radius-pill e-bg-blue-violet text-white e-primary-font-poppins fw-medium e-disable"
              />
            )}
          </div>
        </>
      ) : otpModal ? (
        <>
          <OTPInput
            label="OTP"
            require={true}
            ref={otpInputRef}
            id="otp"
            value={otpValue}
            spellcheck="false"
            error={otpError}
            focused_input={focusedInput}
            confirm_pin={confirmOTP}
            onFocus={() => setFocusedInput(2)}
            onBlur={() => setFocusedInput(0)}
            onKeyPress={_handleSubmitOTP}
            onChange={_handleOTP}
          />

          <div className="row pt-3">
            {/* <Link
              to="/"
              className="text-decoration-none e-font-weight-400 e-font-14 text-muted d-flex align-items-center e-cursor-pointer pb-3"
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              Didn’t get code yet?
              <span className="ps-2 e-text-blue-violet e-font-weight-400 e-font-14">
                Resend OTP
              </span>
            </Link> */}
            <p className="mb-0 text-decoration-none e-font-weight-400 e-font-14 text-muted d-flex align-items-center pb-3">
              Didn’t get code yet?
              <span
                className="e-cursor-pointer ps-2 e-text-blue-violet e-font-weight-500 e-font-14"
                onClick={_handleResendOTP}
              >
                Resend OTP
              </span>
            </p>
          </div>

          <div className="row pt-2">
            <PrimaryButton
              loading={loading}
              ClassName="rounded-pill e-bg-blue-violet text-white e-primary-font-poppins px-3"
              name="Verify"
              onPress={_handleSubmitOTP}
            />
          </div>
        </>
      ) : (
        <>
          <div className="row pt-3">
            <Input
              id="1"
              type="email"
              label="Email"
              placeholder="Enter your email address"
              require={true}
              value={email}
              error={emailError}
              className="e-primary-font-poppins w-100"
              onKeyPress={_validateEmail}
              handleChange={(e) => setEmail(e)}
              autoFocus={true}
            />
          </div>

          <div className="row pt-4 px-2">
            <PrimaryButton
              ClassName="rounded-pill e-bg-blue-violet text-white e-primary-font-poppins fw-medium"
              name={"Verify"}
              loading={loading}
              onPress={_validateEmail}
            />
          </div>
        </>
      )}
    </div>
  );
}
